import React, { Component } from "react";
import { withStyles, Button, TextField, Typography } from "@material-ui/core";
import "./UserDialog.css";

export var styles = function styles(theme) {
	return {
		twoPanes: {
			display: "flex",
			height: "100%",
			paddingTop: "4px",
		},
		contentPane: {
			padding: "4px",
			flex: "1 1 100% !important",
		},
	};
};
class SupportBuildings extends Component {
	constructor(props) {
		super(props);
		this.state = {
			BuildingRequest: "",
		};

		this.changeValue = this.changeValue.bind(this);
		this.sendBuildingRequest = this.sendBuildingRequest.bind(this);
		this.sendRemoveRequest = this.sendRemoveRequest.bind(this);
	}

	async sendBuildingRequest() {
		await fetch("Building/RequestBuilding", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({ building: this.state.BuildingRequest }),
		});
		alert("Your request has been submitted.");
		this.setState({ BuildingRequest: "" });
	}

	async sendRemoveRequest() {
		await fetch("Building/RemoveBuilding", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({ building: this.state.RemoveBuilding }),
		});

		alert("Your request has been submitted.");
		this.setState({ RemoveBuilding: "" });
	}

	changeValue(val, stateVal) {
		var obj = {};
		obj[stateVal] = val;
		this.setState(obj);
	}

	render() {
		return (
			<div className={[this.props.classes.twoPanes, "flex-fill"].join(" ")}>
				<div className={[this.props.classes.contentPane].join(" ")} style={{ borderRight: "1px solid #ebebeb" }}>
					<Typography variant="h4">Request a Building</Typography>
					<Typography style={{ display: "block" }} variant="caption">
						Request a building to be added to your portal. This will give access to all invoices, estimates, and tickets.
					</Typography>
					<TextField size="medium" variant="outlined" label="Building Name" value={this.state.BuildingRequest} onChange={(val) => this.changeValue(val.currentTarget.value, "BuildingRequest")} style={{ marginTop: "8px", marginLeft: "8px", width: "400px" }}></TextField>
					<Button style={{ display: "block", marginLeft: "8px", marginTop: "8px" }} onClick={this.sendBuildingRequest} variant="contained" color="primary">
						Submit
					</Button>
				</div>
				<div className={[this.props.classes.contentPane].join(" ")}>
					<Typography variant="h4">Remove a Building</Typography>
					<Typography style={{ display: "block" }} variant="caption">
						Request a building to be removed from your portal.
					</Typography>
					<TextField size="medium" variant="outlined" label="Building Name" value={this.state.RemoveBuilding} onChange={(val) => this.changeValue(val.currentTarget.value, "RemoveBuilding")} style={{ marginTop: "8px", marginLeft: "8px", width: "400px" }}></TextField>
					<Button style={{ display: "block", marginLeft: "8px", marginTop: "8px" }} onClick={this.sendRemoveRequest} variant="contained" color="primary">
						Submit
					</Button>
				</div>
			</div>
		);
	}
}

export default withStyles(styles, { withTheme: true })(SupportBuildings);
